module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('better-modal', {
    attrs: {
      "closable": true,
      "id": "attributesModal",
      "checkForUnsavedChanges": false
    },
    on: {
      "close-modal": function($event) {
        return _vm.$emit("close-modal")
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.titulos.novoAtributo'))
    }
  }), _c('h4', {
    staticClass: "subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.titulos.cadastre'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form', {
    attrs: {
      "slot": "filters"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate.apply(null, arguments)
      }
    },
    slot: "filters"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attribute.inUse),
      expression: "attribute.inUse"
    }],
    staticClass: "row row-filter-small form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('i', {
    staticClass: "fa fa-info-circle info-icon alert-icon"
  }), _c('span', {
    staticClass: "alert-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.validacao.atributoEmUsoEditar'))
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.identificador'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.name),
      expression: "attribute.name"
    }],
    staticClass: "form-control to-upper",
    class: {
      'is-danger': _vm.errors.has('attributeName')
    },
    attrs: {
      "type": "text",
      "id": "attributeName",
      "name": "attributeName",
      "maxlength": "20",
      "disabled": _vm.attribute.inUse
    },
    domProps: {
      "value": (_vm.attribute.name)
    },
    on: {
      "keyup": _vm.handleIdentifier,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "name", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attributeName')),
      expression: "errors.has('attributeName')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeDescription"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.nome'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.description),
      expression: "attribute.description"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.has('attributeDescription')
    },
    attrs: {
      "type": "text",
      "id": "attributeDescription",
      "name": "attributeDescription",
      "maxlength": "50",
      "disabled": _vm.attribute.inUse
    },
    domProps: {
      "value": (_vm.attribute.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "description", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attributeDescription')),
      expression: "errors.has('attributeDescription')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "type"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.tipo'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} } "
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('attribute.type')
    },
    attrs: {
      "options": _vm.types,
      "id": "type",
      "name": "type",
      "label": "description",
      "data-vv-name": "attribute.type",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "disabled": _vm.attribute.inUse
    },
    on: {
      "input": _vm.toggleAditionalFields
    },
    model: {
      value: (_vm.attribute.type),
      callback: function($$v) {
        _vm.$set(_vm.attribute, "type", $$v)
      },
      expression: "attribute.type"
    }
  }, [_c('span', {
    attrs: {
      "slot": "no-options"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('estabelecimentos.labels.nenhumResultado'))
    },
    slot: "no-options"
  })]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('attribute.type', 'required')),
      expression: "errors.firstByRule('attribute.type', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.attributeTypeHint),
      expression: "attributeTypeHint"
    }],
    staticClass: "col-xs-6 att-field-hint",
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "info-span",
    domProps: {
      "innerHTML": _vm._s(_vm.attributeTypeHint)
    }
  })])]), (_vm.availableFields.value) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "possibleValues"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.valoresPossiveis'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input-tag', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: {required: true} } "
    }],
    class: {
      "input": true,
      "is-danger": _vm.errors.has("attribute.possibleValues")
    },
    attrs: {
      "tags": _vm.attribute.possibleValues,
      "id": "possibleValues",
      "name": "possibleValues",
      "value": "possibleValues.value",
      "disabled": _vm.attribute.inUse
    },
    on: {
      "input": _vm.possibleValuesChanged
    },
    model: {
      value: (_vm.tagsPossibleValue),
      callback: function($$v) {
        _vm.tagsPossibleValue = $$v
      },
      expression: "tagsPossibleValue"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('attribute.possibleValues')),
      expression: "errors.has('attribute.possibleValues')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "col-xs-12 att-field-hint row-filter-small",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticClass: "hint-span",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.infos.dicaCombo'))
    }
  })])]) : _vm._e(), (_vm.availableFields.mask) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeMask"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.mascara'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.mask),
      expression: "attribute.mask"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "attributeMask",
      "type": "text",
      "name": "attributeMask",
      "maxlength": "40",
      "disabled": _vm.attribute.inUse
    },
    domProps: {
      "value": (_vm.attribute.mask)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "mask", $event.target.value)
      }
    }
  })])]) : _vm._e(), (_vm.availableFields.validation) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "attributeValidation"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.labels.validacao'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.attribute.validation),
      expression: "attribute.validation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "attributeValidation",
      "type": "text",
      "name": "attributeValidation",
      "maxlength": "200",
      "disabled": _vm.attribute.inUse
    },
    domProps: {
      "value": (_vm.attribute.validation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.attribute, "validation", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "col-xs-12 att-field-hint row-filter-small",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('span', {
    staticClass: "hint-span",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('conjuntoAtributo.infos.validacao'))
    }
  })])]) : _vm._e()])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "id": "btnCriarNovoAtributo",
      "clickFunction": _vm.validate,
      "label": _vm.$t('conjuntoAtributo.labels.adicionar'),
      "disabled": _vm.attribute.inUse
    }
  }), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "id": "btnFecharModalDeNovoAtributo",
      "label": _vm.$t('conjuntoAtributo.labels.cancelar'),
      "customClass": "secondary",
      "clickFunction": _vm.close
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ddae9a96", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddae9a96"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/attributesSet/newAtributeModal.pug
// module id = 1462
// module chunks = 0